import { DataService } from './dataService'
const promoService = {
	addPromo: async (data) => {
		return DataService.post('/admin/add_promo', data)
	},

	updatePromo: async (data) => {
		return DataService.post('/admin/update_promo' ,data)
	},

	deletePromo: async (data) => {
		return DataService.post('/admin/delete_promo' ,data)
	},

    getPromo: async (data) => {
		return DataService.get('/admin/get_promo', data)
	},

}

export default promoService